const AppcuesFlowManagerHook = {
  mounted() {
    // Initialize with empty tracking set to avoid duplicate triggering
    this.triggeredFlows = new Set()

    this.handleEvent("appcues:trigger-flow", (flow) => {
      // Don't request same flow multiple times
      if (this.triggeredFlows.has(flow.name)) return

      // Mark as triggered to prevent duplicates
      this.triggeredFlows.add(flow.name)

      this.triggerFlow(flow.id, flow.name)
    })

    // Implement a clean URL fragment-based approach for flow triggering
    this.flowFragmentManager = {
      originalFragment: null,

      // Apply flow trigger fragment
      applyFlowTrigger: (flowId, flowName) => {
        // Save current fragment
        this.flowFragmentManager.originalFragment = window.location.hash
        this.flowFragmentManager.flowStarted = false

        // Apply the flow trigger fragment
        const triggerFragment = `#appcues-flow-${flowId}`

        if (window.Appcues) {
          const onStarted = (event) => {
            if (event.flowId !== flowId) return
            window.Appcues.off("flow_started", onStarted)
            this.flowFragmentManager.flowStarted = true
            console.log("Appcues started a flow with ID " + event.flowId)

            const onCompleted = (event) => {
              if (event.flowId !== flowId) return
              window.Appcues.off("flow_completed", onCompleted)
              window.Appcues.off("flow_skipped", onSkipped)
              console.log("Appcues completed a flow with ID " + event.flowId)
              if (window.location.hash == triggerFragment) {
                this.flowFragmentManager.restoreOriginal()
              }
            }

            const onSkipped = (event) => {
              if (event.flowId !== flowId) return
              window.Appcues.off("flow_skipped", onSkipped)
              window.Appcues.off("flow_completed", onCompleted)
              console.log("Appcues skipped a flow with ID " + event.flowId)
              if (window.location.hash == triggerFragment) {
                this.flowFragmentManager.restoreOriginal()
              }
            }
            window.Appcues.on("flow_completed", onCompleted)
            window.Appcues.on("flow_skipped", onSkipped)
          }
          window.Appcues.on("flow_started", onStarted)

          // After a short delay, if the flow is not started then
          // assume that it is already shown and remove hash
          setTimeout(() => {
            if (
              !this.flowFragmentManager.flowStarted &&
              window.location.hash == triggerFragment
            ) {
              console.log(`Appcues timeout reset hash`)
              this.flowFragmentManager.restoreOriginal()
              window.Appcues.off("flow_started", onStarted)
            } else {
              console.log(`Appcues timeout ignore`)
            }
          }, 2000)
        }

        window.location.hash = triggerFragment

        // Force Appcues to evaluate URL rules
        if (window.Appcues) {
          window.Appcues.page()
        } else {
          // If Appcues isn't loaded yet, wait for it
          let attempts = 0
          const checkAppcues = () => {
            if (window.Appcues) {
              this.announceFlowRequest(flowId, flowName)
              window.Appcues.page()
            } else if (attempts < 25) {
              attempts++
              setTimeout(checkAppcues, 200)
            }
          }
          checkAppcues()
        }
      },

      // Restore original fragment
      restoreOriginal: () => {
        if (this.flowFragmentManager.originalFragment) {
          history.replaceState(
            null,
            document.title,
            this.flowFragmentManager.originalFragment,
          )
        } else {
          // Remove fragment if there wasn't one
          history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search,
          )
        }
      },
    }
  },

  // Trigger a flow using URL targeting
  triggerFlow(flowId, flowName) {
    this.announceFlowRequest(flowId, flowName)
    this.flowFragmentManager.applyFlowTrigger(flowId, flowName)

    // clear cache after 5s
    setTimeout(() => {
      this.triggeredFlows.delete(flowName)
    }, 5000)
  },

  announceFlowRequest(id, name) {
    window.dispatchEvent(
      new CustomEvent("enaia:appcues-flow-requested", { detail: { id, name } }),
    )
  },
}

export { AppcuesFlowManagerHook }
